module.exports = __webpack_public_path__ + "static/media/anquan-logo.e590c6cb.svg";